<div class="option-content-particularity">
    <span class="option-title">Respeta exención de IVA</span>

    <div class="actions">
        <input type="checkbox" (click)="setRespectVAT()" [checked]="isRespectVAT" class="checkbox" />
    </div>
</div>